"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    margin: 0;\n    width: 100%;\n    cursor: pointer;\n    padding: ", ";\n    background: ", ";\n    color: ", ";\n    &:not(:last-child) {\n        border-bottom: ", ";\n    }\n    &:hover {\n        background: ", ";\n    }\n"], ["\n    margin: 0;\n    width: 100%;\n    cursor: pointer;\n    padding: ", ";\n    background: ", ";\n    color: ", ";\n    &:not(:last-child) {\n        border-bottom: ", ";\n    }\n    &:hover {\n        background: ", ";\n    }\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MenuItem = _styledComponents2.default.li(_templateObject, function (props) {
    return props.theme.menu.padding / 2 + "em " + props.theme.menu.padding + "em";
}, function (props) {
    return props.theme.menu.background;
}, function (props) {
    return props.theme.menu.color;
}, function (props) {
    return props.theme.menu.borderBottom;
}, function (props) {
    return props.theme.menu.hoverBackground;
});

exports.default = MenuItem;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/menu/menuItem.js
// module id = 1013
// module chunks = 95715928098905 168707334958949